// US address helpers for checkout: the 50 states + DC (inline, instant) and a
// lazily-loaded city/ZIP table (util/usPlaces.json, built from the GeoNames
// US postal-code file, CC BY 4.0 geonames.org — ~240 KB gzipped, fetched only
// when a shopper focuses City or ZIP).

export const US_STATES = [
  ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'], ['CA', 'California'],
  ['CO', 'Colorado'], ['CT', 'Connecticut'], ['DE', 'Delaware'], ['DC', 'District of Columbia'], ['FL', 'Florida'],
  ['GA', 'Georgia'], ['HI', 'Hawaii'], ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'],
  ['IA', 'Iowa'], ['KS', 'Kansas'], ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'],
  ['MD', 'Maryland'], ['MA', 'Massachusetts'], ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'],
  ['MO', 'Missouri'], ['MT', 'Montana'], ['NE', 'Nebraska'], ['NV', 'Nevada'], ['NH', 'New Hampshire'],
  ['NJ', 'New Jersey'], ['NM', 'New Mexico'], ['NY', 'New York'], ['NC', 'North Carolina'], ['ND', 'North Dakota'],
  ['OH', 'Ohio'], ['OK', 'Oklahoma'], ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'], ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'], ['UT', 'Utah'],
  ['VT', 'Vermont'], ['VA', 'Virginia'], ['WA', 'Washington'], ['WV', 'West Virginia'], ['WI', 'Wisconsin'],
  ['WY', 'Wyoming'],
];

const NAME_BY_CODE = Object.fromEntries(US_STATES);

// "tx", "Texas", "texas " → "TX"; anything else → ''.
export const toStateCode = (v) => {
  const s = String(v ?? '').trim();
  if (!s) return '';
  const up = s.toUpperCase();
  if (NAME_BY_CODE[up]) return up;
  const hit = US_STATES.find(([, n]) => n.toLowerCase() === s.toLowerCase());
  return hit ? hit[0] : '';
};
export const stateName = (code) => NAME_BY_CODE[String(code ?? '').toUpperCase()] ?? '';

let loading = null;
// → { zip(z) → {city, state} | null, cities(state) → string[] }
export const loadUsPlaces = () => {
  if (!loading) {
    loading = import('./usPlaces.json').then((mod) => {
      const d = mod.default ?? mod;
      const zips = new Map();
      const byState = new Map();
      for (const rec of String(d.zips).split(';')) {
        const zip = rec.slice(0, 5);
        const [c, s] = rec.slice(5).split('.');
        const city = d.cities[parseInt(c, 16)];
        const st = d.states[parseInt(s, 16)];
        zips.set(zip, { city, state: st });
        if (!byState.has(st)) byState.set(st, new Set());
        byState.get(st).add(city);
      }
      const sorted = new Map([...byState].map(([st, set]) => [st, [...set].sort((a, b) => a.localeCompare(b))]));
      return {
        zip: (z) => zips.get(String(z ?? '').trim().slice(0, 5)) ?? null,
        cities: (st) => sorted.get(String(st ?? '').toUpperCase()) ?? [],
      };
    }).catch((e) => { loading = null; throw e; });
  }
  return loading;
};
